import React from 'react';
import Counter from '../../components/Counter';

const FunFact = () => {
  const counters = [
    {
      countIcon: 'flaticon-rating',
      countNum: 50,
      countSubtext: '+',
      countTitle: 'Happy Patients',
    },
    {
      countIcon: 'flaticon-completed-task',
      countNum: 15,
      countSubtext: '+',
      countTitle: 'Campaign Complete',
    },
    {
      countIcon: 'flaticon-people',
      countNum: 2,
      countSubtext: 'K',
      countTitle: 'Total Doctors',
    },
    {
      countIcon: 'flaticon-medal',
      countNum: 30,
      countSubtext: '+',
      countTitle: 'Award Won',
    },
  ];
  return (
    <div className="it-funfact-area funfact-ptb fix z-index-3 theme-bg">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="it-funfact-item-box flex-wrap d-md-flex align-content-center justify-content-md-between">
              {counters.map((counter, index) => (
                <div
                  key={index}
                  className="it-funfact-item d-flex align-items-center"
                >
                  <span className="it-funfact-icon">
                    <i className={counter.countIcon}></i>
                  </span>
                  <div>
                    <h5 className="it-funfact-number text-white">
                      <Counter
                        start={0}
                        end={counter.countNum}
                        duration={3}
                        counterSubText={counter.countSubtext}
                      />
                    </h5>
                    <span className="text-white it-funfact-title">
                      {counter.countTitle}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunFact;
